import React, { Fragment, PureComponent } from 'react';

import { Button } from 'components/button';
import { InputDropdown } from 'components/input/dropdown';
import { Modal } from 'components/modal';
import { I18n, Polyglot } from 'components/translate';
import PropTypes from 'prop-types';

import SubtitleTranslationChecklist from './SubtitleTranslationChecklist';

import SubtitleActions from '../../SubtitleActions';

const LANGUAGES_SEPARATOR = ', ';

export default class SubtitleTranslateModal extends PureComponent {
  state = {
    selectedLanguages: []
  };

  static propTypes = {
    onConfirmTranslate: PropTypes.func,
    mediaId: PropTypes.string,
    subtitleId: PropTypes.string,
    translatedCodes: PropTypes.array
  };

  get isTranslateEnabled() {
    const { selectedLanguages } = this.state;

    return selectedLanguages.length > 0;
  }

  get selectedLanguagesText() {
    const { selectedLanguages } = this.state;

    return selectedLanguages
      .map((lang) => Polyglot.t(`supported_languages.${lang}`))
      .join(LANGUAGES_SEPARATOR);
  }

  render() {
    const { mediaId, translatedCodes } = this.props;

    return (
      <Modal
        className="subtitle__modal subtitle__modal__translate"
        {...this.props}
      >
        <Modal.Header>
          <h5 className="modal-header-warning">
            <I18n label="player_subtitles.label" />
          </h5>
          <h2 className="mt__sm">
            <I18n label="player_subtitles.translate.title" />
          </h2>

          <Modal.Close />
        </Modal.Header>

        <Modal.Body>
          <label>
            <I18n label="player_subtitles.translate.description" />
          </label>

          <InputDropdown
            selected={this.selectedLanguagesText}
            preventCloseOnDropdownListClick
            dropdownListFixed
            placeholder="player_subtitles.translate.choose_langs"
          >
            <SubtitleTranslationChecklist
              mediaId={mediaId}
              onSelectLang={this.onSelectLanguage}
              translatedCodes={translatedCodes}
            />
          </InputDropdown>
        </Modal.Body>
        <Modal.Footer>{this.renderModalFooter}</Modal.Footer>
      </Modal>
    );
  }

  renderModalFooter = ({ actions }) => {
    return (
      <Fragment>
        <Button
          size="large"
          onClick={() => this.onConfirmTranslate(actions)}
          disabled={!this.isTranslateEnabled}
        >
          <I18n label="player_subtitles.translate.label" />
        </Button>
        <Button size="large" outline onClick={actions.closeModal}>
          <I18n label="general.cancel" />
        </Button>
      </Fragment>
    );
  };

  onSelectLanguage = (selectedLanguages) => {
    this.setState({ selectedLanguages });
  };

  onConfirmTranslate = (actions) => {
    const { selectedLanguages } = this.state;
    const { subtitleId, mediaId } = this.props;

    actions.closeModal();
    SubtitleActions.translateSubtitles(subtitleId, mediaId, selectedLanguages);
  };
}
